// extracted by mini-css-extract-plugin
export default {"Input":"VueRapport_Input__vSFyO","contenuEnTete":"VueRapport_contenuEnTete__5Lmch","titre":"VueRapport_titre__YBi3z","bold":"VueRapport_bold__DBZD8"};